var map = {
	"./accounting/coa-category.js": "327b",
	"./accounting/coa-mapping.js": "6d29",
	"./accounting/coa-setup.js": "814a",
	"./accounting/journal-entry.js": "99d3d",
	"./auth/role.js": "cb6a",
	"./auth/user.js": "cb3e",
	"./corporate/branch-expire-contract.js": "b299",
	"./corporate/branch.js": "39e0",
	"./corporate/citizenship-statistic.js": "58d7",
	"./corporate/company.js": "052b",
	"./credit-operation/customer-loan-purpose.js": "67fc",
	"./credit-operation/customer-loan-request.js": "fd5c",
	"./credit-operation/customer.js": "d2f5",
	"./credit-operation/eod-rollback-history.js": "00cb",
	"./credit-operation/eod.js": "7a8d",
	"./credit-operation/loan-currency.js": "2998",
	"./credit-operation/loan-disbursement.js": "1197",
	"./credit-operation/loan-recovery.js": "d212",
	"./credit-operation/loan-repayment-deleted.js": "44bb",
	"./credit-operation/loan-repayment.js": "8e22",
	"./credit-operation/loan-transfer.js": "f6db",
	"./credit-operation/loan-type.js": "e1b5",
	"./credit-operation/loan-write-off.js": "b20e",
	"./credit-operation/occupation.js": "3b35",
	"./customer-service/repair-product-profile.js": "8d9c",
	"./customer-service/service-quotation.js": "446c",
	"./customer-service/service-ticket.js": "514f",
	"./customer/dealer-grade.js": "8785",
	"./customer/profile.js": "f49e",
	"./human-resource/attendance-device.js": "74dd",
	"./human-resource/basic-salary-formula.js": "0451",
	"./human-resource/basic-salary.js": "b7c5",
	"./human-resource/daily-attendance.js": "e729",
	"./human-resource/employee.js": "e114",
	"./human-resource/holiday-rule.js": "3bd4",
	"./human-resource/holiday.js": "0f76",
	"./human-resource/job-detail.js": "fa76",
	"./human-resource/job-level.js": "4ae5",
	"./human-resource/job-title.js": "9683",
	"./human-resource/leave-initial-balance.js": "9017",
	"./human-resource/leave-record.js": "bac5",
	"./human-resource/leave-rule.js": "dcd4",
	"./human-resource/leave-sub-item.js": "3063",
	"./human-resource/nationality.js": "d98b",
	"./human-resource/organizational-chart.js": "7d17",
	"./human-resource/organizational-structure.js": "c1e6",
	"./human-resource/payroll-cycle-date.js": "8496",
	"./human-resource/payroll-cycle.js": "b207",
	"./human-resource/position-hierarchy.js": "a23b",
	"./human-resource/shift-management.js": "063f",
	"./human-resource/teaching-calendar.js": "8567",
	"./human-resource/work-schedule.js": "c1e6e",
	"./index.js": "2a74",
	"./payroll/first-cycle-paid.js": "0eb9",
	"./payroll/fixed-allowance.js": "0c87",
	"./payroll/fixed-incentive-bonus.js": "7ae5",
	"./payroll/item-allowance.js": "50d3",
	"./payroll/item-compensate.js": "d3d3",
	"./payroll/item-deduction.js": "37f4",
	"./payroll/item-incentive-bonus.js": "d4f3",
	"./payroll/item-overtime.js": "68f3",
	"./payroll/monthly-allowance.js": "abb3",
	"./payroll/monthly-compensate.js": "ad1c",
	"./payroll/monthly-deduction.js": "46d0",
	"./payroll/monthly-incentive-bonus.js": "5c52",
	"./payroll/monthly-overtime.js": "69c4",
	"./payroll/overtime-rule-by-shift.js": "bd92",
	"./payroll/pay-user-variable.js": "4e8d",
	"./payroll/payroll-calculation.js": "6a9a",
	"./payroll/payroll-template.js": "7f95",
	"./payroll/payslip-template.js": "8b35",
	"./payroll/pension-contribution-wage.js": "3903",
	"./payroll/pension-rate.js": "99cd1",
	"./payroll/tax-range.js": "3369",
	"./payroll/working-hours.js": "bf8c",
	"./product/product-category.js": "9570",
	"./product/product-group.js": "fef5",
	"./product/profile.js": "d749",
	"./product/uom-category.js": "9937",
	"./report/accounting.js": "258a",
	"./report/attendance-detail.js": "484c",
	"./report/attendance-summary.js": "2ca8",
	"./report/basic-salary-history.js": "0df1",
	"./report/credit-operation.js": "5bad",
	"./report/employee-profile.js": "7dda",
	"./report/leave-report.js": "2f31",
	"./report/nssf-report.js": "ac3f",
	"./report/payroll-detail.js": "7976",
	"./report/payslip.js": "9b3f",
	"./report/resource.js": "0378",
	"./report/summary-report-pension-fund-and-insurance.js": "e4f5",
	"./setting/approval-flow.js": "7229",
	"./setting/system.js": "0c44",
	"./stock/warehouse.js": "3ce0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0308";